module.exports = __webpack_public_path__ + "img/app_sub_true.1b908da2.svg";